export const fetchTextFile = async (filePath: string): Promise<any> => {
  try {
    const response = await fetch(filePath);
    if (!response.ok) {
      throw new Error(`Failed to fetch ${filePath}`);
    }
    return response;
  } catch (error) {
    console.error(`Error reading file: ${error}`);
    return "Error reading file";
  }
};
